import { Button, HStack } from '@chakra-ui/react';
import { Service } from 'shared/models/service';
import { Software } from 'shared/models/software';
import { Periodicity } from 'shared/types/periodicity';
import { LabeledSelect, Option } from '../atoms/LabeledSelect';

interface PlanSelectorProps {
  product?: Software;
  periodicity?: Periodicity;
  selectedPlan?: Service;
  setSelectedPlan: (p?: Service) => void;
  addedServiceIds: number[];
  onSave: (plan: Service) => void;
}

export const PlanSelector: React.FC<PlanSelectorProps> = ({
  product,
  periodicity,
  selectedPlan,
  setSelectedPlan,
  addedServiceIds,
  onSave,
}) => {
  const servicesWithId = (product?.services ?? []).filter(
    (service): service is Service & { id: number } =>
      typeof service.id === 'number',
  );

  const options: Option[] = servicesWithId
    .filter((service) => service.periodicity === periodicity)
    .sort((a, b) => (a.name || '').localeCompare(b.name || '', 'pt-BR'))
    .map((service) => {
      const id = service.id as number;
      return {
        value: id,
        label: `${service.name} - ${service.priceString}`,
        disabled: addedServiceIds.includes(id),
      };
    });

  const handleChange = (value: string) => {
    const id = Number(value);
    const plan = servicesWithId.find((plan) => plan.id === id);
    setSelectedPlan(plan);
  };

  return (
    <HStack align="flex-end" spacing={4} px={'8px'}>
      <LabeledSelect
        label="Selecionar"
        value={selectedPlan ? String(selectedPlan.id) : ''}
        onChange={handleChange}
        options={options}
      />
      <Button
        colorScheme="yooga"
        minW="fit-content"
        isDisabled={!selectedPlan}
        onClick={() => selectedPlan && onSave(selectedPlan)}
      >
        Salvar
      </Button>
    </HStack>
  );
};
